import { defineMessages } from 'react-intl';

export const offerMessages = defineMessages({
  'offers:activateButtonTitle': {
    id: 'offers:activateButtonTitle',
    defaultMessage: 'Activate',
    description: 'Activate offer button text',
  },
  'offers:redeemButtonTitle': {
    id: 'offers:redeemButtonTitle',
    defaultMessage: 'Redeem',
    description: 'Redeem offer button text',
  },
  expiresDays: {
    id: 'voucherDuration:days',
    defaultMessage: '{expiresIn, plural, one {# day} other {# days}}',
    description: 'Redeem offer expiration days',
  },
  expiresHours: {
    id: 'voucherDuration:hours',
    defaultMessage: '{expiresIn, plural, one {# hour} other {# hours}}',
    description: 'Redeem offer expiration hours',
  },
  expiresLessThanHour: {
    id: 'voucherDuration:lessThanHour',
    defaultMessage: 'less than one hour',
    description: 'Redeem offer expiration less than hour',
  },
  expiresAnHour: {
    id: 'voucherDuration:anHour',
    defaultMessage: 'one hour',
    description: 'Redeem offer expiration an hour',
  },
  activationFailed: {
    id: 'offers:activationFailed',
    defaultMessage: 'This offer cannot be activated at this time. Please try again later.',
    description: 'Error message, when offer can not be activated.',
  },
});
